<template>
    <transition name="el-zoom-in-top">
        <div class="content-wrapper">
       <!-- Content Header (Page header) -->
        <section class="content-header">
          <div class="titleDiv">
                
                    <h2><strong>Policy List</strong></h2>
                    <hr>
                    <h4>View your insurance policies here.</h4>
<br>                    
        
       
            </div>
        </section>
  
            <!-- Main content -->
            <section class="content">
               <!-- Expandable Table-->
                <div class="box">
                    <div class="box-header with-border">
                        <h3 class="box-title">Policy List</h3>
                        <div class="box-tools pull-right">
                            <button type="button" data-widget="collapse" data-toggle="tooltip" title="Collapse" class="btn btn-box-tool"><i class="ti-minus"></i></button>
                        </div>
                    </div>
                    <div id="table" class="box-body">
                        <el-table
                        empty-text="There is no policy data to display."
                        :data="policyList"
                        style="width: 100%;">
                        <el-table-column type="expand" >
                          <template scope="props">
                            <div>
                              <h3><strong>Policy Details</strong></h3>
                              <hr>
                            <p><strong>Provider's Name:</strong> {{ props.row.providerName }}</p>
                            <p><strong>PolicyHolder's Name:</strong> {{ props.row.policyName }}</p>
                            <p><strong>Policy No.:</strong> {{ props.row.policyNumber }}</p>
                            <p><strong>Address on Policy:</strong> {{ props.row.policyAddress }}</p>
                          </div>
                            <br>
                             <div>
                               <h3><strong>Vehicle Details</strong></h3>
                               <hr>
                               <h4>List of Vehicles on Policy:</h4>
                               <hr>
                               <div v-for="vehicle in props.row.vehicleList">
                            <p><strong>Vehicle Year:</strong> {{vehicle.yearValue }}</p>
                            <p><strong>Vehicle Make:</strong> {{vehicle.makeValue }}</p>
                            <p><strong>Vehicle Year:</strong> {{vehicle.modelValue }}</p>
                            <p><strong>Vehicle's VIN:</strong> {{vehicle.vinNumber }}</p>
                            <p><strong>License Plate No.:</strong> {{vehicle.licensePlateNumber }}</p>  
                            <hr>
                            </div>
                            

                            </div>
                            <br>
                             <div>
                               <h3><strong>Other Details Noted</strong></h3>
                               <hr>
                            <p><strong>Agent Name:</strong> {{ props.row.agentName }}</p>
                                                        <p><strong>Agent Phone No.:</strong> {{ props.row.agentPhone }}</p>

                            <hr>
                           
                            </div>

                          </template>
                        </el-table-column>
                       
               
                        <el-table-column
                          label="Provider Name"
                          >
                         <template slot-scope="scope">
    <span class="bold"><strong>{{scope.row.providerName}}</strong></span>
                </template>
                        </el-table-column>
                         
                         <el-table-column
                          label="Policy Number"
                          prop="policyNumber">
                        </el-table-column>
                         <el-table-column
                          label="Options"
                          >
                          <template scope="props">
                         <button class="btn btn-success" v-on:click="editPolicy(props.row.policyId)"> <span class="fa fa-edit"></span>&nbsp;&nbsp;Edit Policy</button>
                        <button class="btn btn btn-danger" v-on:click="deletePolicy(props.row.policyId)"><span class="fa fa-minus-circle"></span>&nbsp;&nbsp;Delete Policy</button>
                          </template>
                        </el-table-column>
                      </el-table>
                      <br>
                      <router-link to="/policies/addPolicy">
                          <el-button style="margin-left:40%;" size="small" type="primary"><span class="fa fa-plus-circle"></span>&nbsp;&nbsp;Add New Policy</el-button>
                      </router-link>
                    </div>
                </div>
                <!-- End of Expandable Table-->
          
            </section>
            <!-- /.content -->
        </div>
    </transition>
</template>
<script>
        const cliStorage = require('../../services/libraries/clientStoragelib')
        const cliStoreOps = require('../../common/clientStorageOperations')
const cliStorNames = cliStorage.clientStorageNames
const Auth = require('../../services/Authentication/auth')
const db = require('../../services/database/database')
  const commonDB = require('../../services/database/common')
const _ = require('lodash')

const models = require('../../services/database/models')
        var to = require('await-to-js').default
    export default {
      name: 'PolicyList',
      async beforeMount(){
        console.log("cli names", cliStorNames)
        const userToken = this.$cookie.get(cliStorNames.USER_TOKEN.name)
        if (!userToken){
            cliStoreOps.deleteAllCookies()
                        cliStoreOps.deleteAllLocalStorageItems()

            this.$router.push('/login')
        }
        this.userToken = userToken
         const jwt_decode = require('jwt-decode');
      const decoded_header = jwt_decode(this.userToken)
      this.userAccountId = decoded_header.user_id
        let userErr, userRes;
          [userErr, userRes] = await to(Auth.getUser({ UID: userToken }));
          if (userErr) {
            console.log("getting user userErr", userErr.response);
    cliStoreOps.deleteAllCookies()
                        cliStoreOps.deleteAllLocalStorageItems()

            this.$router.push('/login')
          } else if (userRes) {
              console.log("userRes",userRes)
              const userId = this.$cookie.get(cliStorNames.USER_ID.name)
              if (!userId)
              {
                //TODO: eventually need to add plan B here, maybe just look up the user and get the ID
                console.warn("No user id found.")
              }

              this.userId = userId
let userDbRes, userDbErr; 
                  [userDbErr, userDbRes]= await to(commonDB.getUserFromDB(this.userToken, this.userAccountId, this.userId))
                  if (userDbErr){
                      console.error(userDbErr)
                      this.$confirm("Unable to Load Profile Contents. Please try again at a later time.", 'User Profile Error', {
        cancelButtonText: 'Cancel',
        confirmButtonText: 'OK',
        type:'error'}).then(this.$router.push('/'))
                  }
                 
                                    let pulledUserId = userDbRes.data.fields.userId.stringValue
                                    //VERY IMPORTANT! ==> Keeps 1 user from accesing another user's profile
                if (pulledUserId !== this.userId){
                     this.$confirm("Unable to retrieve User Profile. Please try again at a later time.", 'User Profile Error', {
        cancelButtonText: 'Cancel',
        confirmButtonText: 'OK',
        type:'error'}).then(this.$router.push('/'))
}
               let dbRes, dbErr; 
                  [dbErr, dbRes]= await to(commonDB.getPoliciesFromDB(this.userToken, this.userAccountId))
                  if (dbErr){
                      console.error(dbErr)
                              this.$confirm("Unable to load Insurance Policies " + userErr.response.data.message, 'Load Insurance Policies Error', {
        cancelButtonText: 'Cancel',
        confirmButtonText: 'Ok',
        type:'error'}).then(this.$router.push('/'))
                  }
                  try{
                  console.log("Res", dbRes)
                   if(!_.isEmpty(dbRes) && !_.isEmpty(dbRes.data)){
                  for (var entry of  dbRes.data.documents){
                     if(!entry){ //to prevent crashing
                      break;
                    }
                    let policy = {}
                     policy.policyNumber = entry.fields.policyNumber.stringValue
                                    policy.policyName = entry.fields.policyName.stringValue

                  policy.providerName = entry.fields.providerName.stringValue
                  policy.policyAddress = entry.fields.policyAddress.stringValue
                  policy.agentName = entry.fields.agentName.stringValue
                  policy.agentPhone = entry.fields.agentPhone.stringValue
                  policy.policyId = entry.fields.policyId.stringValue
                  let vehicleList = []
                  if(entry.fields.vehicleList.arrayValue.values){
                        vehicleList = entry.fields.vehicleList.arrayValue.values
                  }
                   
                  console.log("to vh l", vehicleList)
                    let policyVehicleList = []

                  for(let i of vehicleList){
                    let vehicleObj = {};
                     let keys = Object.keys(i.mapValue.fields)
                                             console.log(i)

                      keys.forEach((key, index) => {
                        console.log(i.mapValue.fields[key])
                      vehicleObj[key] = i.mapValue.fields[key].stringValue

                    })
                    policyVehicleList.push(vehicleObj)
                  
                  }
                                    console.log("done with vh l")


                  policy.vehicleList = policyVehicleList
                  
                  this.policyList.push(policy)
                  console.log("VL", this.policyList)

      }
                  }
                                  
      }
      catch(err){
                    console.error("ERROR", err)
                     this.$confirm("Unable to retrieve Policy Entries. Please try again at a later time.", 'Policy List Error', {
        cancelButtonText: 'Cancel',
        confirmButtonText: 'OK',
        type:'error'}).then(this.$router.push('/'))
                  }
          }
      
      },
      data: function () {
        return {
          userId: '',
          policyList: [],
          userToken: ''
         
        }
      },
      methods:
      {
        
        
        editPolicy: function(policyId){
          console.log("policyID", policyId)
          this.$cookie.set(cliStorNames.POLICY_ID.name, policyId)
        this.$router.push('/policies/'+policyId+'/EditPolicy')

        },

         deletePolicy: async function(policyId){
        let userNo, userYes;
        [userNo, userYes] = await to(this.$confirm("Are you sure you want to delete this policy?" ,  'WARNING', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'}))

        if (userNo){
            console.log("no")
        }
    //     if(userYes){
    //         let confirmNo, confirmYes;
    //         [confirmNo, confirmYes] = await to(this.$confirm("Are you absolutely sure you want to delete your profile?",  'WARNING', {
    //              auth: true,
    //     confirmButtonText: 'Yes',
    //     cancelButtonText: 'No'})
    // )

        if(userYes){
        
const jwt_decode = require('jwt-decode');

         const decoded_header = jwt_decode(this.userToken)
          const userAccountId = decoded_header.user_id
         const documentPath = "users/" + userAccountId + "/policies/" + policyId   //res.data[0].name

         let delErr, delRes;

         [delErr, delRes] = await to(db.deleteDocument(this.userToken, documentPath))

         if (delErr){
           console.error(delErr)
         }
                  this.policyList = this.policyList.filter(e => e.policyId !== policyId)

//this.updateDiv("#table")
         //location.reload();

        
        }
        
    },
     updateDiv: function(id)
{ 
    $( id ).load(window.location.href + id );
},

      

             
      convertAccidentType: function(unformattedAccidentType){
        return this.accidentTypeMap [unformattedAccidentType]
      }
      }
    }
</script>
<style scoped>

@media(min-width: 500px) {
.titleDiv {
  background:white;
  
}
}
@media(max-width: 500px){
  .titleDiv {
  background:white;
  margin-top: 10%;
  
}
}
</style>


// WEBPACK FOOTER //
// PolicyList.vue?23b590e1